import "./About.css";
import "../../styles/App.css";
import Navbar from "../../components/Navbar/Navbar.js";
import Footer from "../../components/Footer/Footer.js";
import aboutImage from "../../assets/ethanAboutImage.jpg";
import myResume from "../../assets/Ethan_Hair_Resume.pdf";

function About() {
    return (
        <div className="About-Page">
            <Navbar />

            <div className="about-hero" style={{ backgroundImage: `url(${aboutImage})` }}>
                <h1>About Me</h1>
            </div>

            <div className="about-content-details">
                <h2>Hi, I'm Ethan</h2>
                <p>
                    A Computer Science graduate based in Melbourne, Australia, with a major in Software Development. 
                    I enjoy working on building solutions to solve technical problems, and continuously improving my skills as a developer.
                </p>
                <p>
                    I recently completed a Frontend Engineering Internship where I contributed to a production web application, working on feature development, analytics tracking, debugging, and UI improvements.
                    The experience help to expose me to real world implementations of Agile workflows, collaborative software development, and data-driven decision making and tools.
                </p>
            </div>

            <div className="about-content">
                <div className="about-content-left">
                    <div className="about-content-experience">
                        <h2>Experience</h2>
                        <h3>Frontend Engineering Intern</h3>
                        <h4>
                            <a href="https://www.foriio.com/" target="_blank" rel="noopener noreferrer">Foriio</a> | 01/2026 - 02/2026
                        </h4>
                        <ul>
                            <li>Contributed to the development and optimisation of a production web application, focusing on PRO subscription features</li>
                            <li>Implemented analytics tracking across the platform, capturing user interactions, feature usage, and behavioural data</li>
                            <li>Instrumented key events (e.g. feature interactions, click tracking, active users) to support KPI measurement and product decision-making</li>
                            <li>Developed tracking logic to differentiate between free and PRO users using attributes such as user ID, subscription status, and activity metrics</li>
                            <li>Assisted in building and refining internal dashboards to visualise user data and feature performance</li>
                            <li>Contributed to improving feature adoption by implementing paywalls, call-to-action components, and PRO-focused UI elements</li>
                            <li>Produced insights used in a UI/UX feature ranking report that informed product strategy</li>
                            <li>Resolved bugs and usability issues including broken UI elements, drag-and-drop functionality, and formatting inconsistencies</li>
                            <li>Improved overall user experience through interface fixes and enhancements across key pages</li>
                        </ul>
                    </div>
                </div>

                <div className="about-content-right">
                    <div className="about-content-skills">
                        <h2>Skills</h2>
                        <ul>
                            <li><b>Programming Languages:</b> HTML, CSS, Python, C++, C#, JavaScript</li>
                            <li><b>Frameworks/Libraries:</b> React, Pygame, ROS2</li>
                            <li><b>Tools:</b> Git & Version Control, VSCode, Project Management (Atlassian)</li>
                            <li><b>Development Practives:</b> Agile methodology, Sprint Planning, Stand-ups, Debugging, Testing</li>
                            <li><b>Soft Skills:</b> Problem-solving, Teamwork, Independant initiative</li>
                        </ul>
                    </div>

                    <div className="about-content-education">
                        <h2>Education</h2>
                        <h3>
                            Bachelor of Computer Science <br/>
                            (Software Development)
                        </h3>
                        <h4>
                            <a href="https://www.swinburne.edu.au/" target="_blank" rel="noopener noreferrer">Swinburne University of Technology</a> | 2023 - 2026
                        </h4>
                    </div>
                </div>
            </div>
            
            <a href={myResume} download>
                <button className="resume-btn">Download Resume</button>
            </a>
            <Footer />
        </div>
    );
}

export default About;